import { ParentProps, createContext } from 'solid-js'
import { requireContext } from 'common'
import { IacMenuContext } from './IacMenuContext'
import { loadIACData } from './IACStore'
import styles from './st-iac-menu.module.css'

// Make this method available to legacy controls (for now)
window.ST.LoadIACData = loadIACData;

const IacMenuContextJsx = createContext<IacMenuContext>();
export const requireIacMenuContext = () => {
    return requireContext(IacMenuContextJsx);
}

export class IacMenuProps { }

export default function IacMenu(props: ParentProps<IacMenuProps>) {
    const context = new IacMenuContext();

    return (
        <IacMenuContextJsx.Provider value={context}>
            <IacMenuInternal {...props} />
        </IacMenuContextJsx.Provider>
    )
}

function IacMenuInternal(props: ParentProps<IacMenuProps>) {
    return (
        <div class={styles['st-iac-menu']}>
            {props.children}
        </div>
    );
}

IacMenu.defaultProps = new IacMenuProps();
